import React from 'react';

const UpcomingPayments = () => <div>UpcomingPayments</div>;

export default UpcomingPayments;
